import React, { useEffect } from 'react';
import styles from '../../styles/dialogbox/DialogBox.module.css';

const DialogBox = ({ isOpen, title, message, onConfirm, onCancel, type = 'info' }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add(styles.bodyOverflow);
    } else {
      document.body.classList.remove(styles.bodyOverflow);
    }

    return () => {
      document.body.classList.remove(styles.bodyOverflow);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={styles.dialogOverlay}>
      <div className={styles.dialogContent}>
        <div className={`${styles.dialogHeader} ${styles[type]}`}>
          <h2>{title}</h2>
        </div>
        <div className={styles.dialogBody}>
          <p>{message}</p>
        </div>
        <div className={styles.dialogActions}>
          <button 
            className={`${styles.button} ${styles.cancelButton}`}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button 
            className={`${styles.button} ${styles[`${type}Button`]}`}
            onClick={onConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default DialogBox;